import { FormControl, FormHelperText } from '@material-ui/core'
import React, { forwardRef } from 'react'
import Input from '../Input'
import useStyles from './useStyles'

interface Props {
  label: string
  labelClassName?: unknown
  errorMessage?: string
  [key: string]: unknown
}

const Field: React.FC<Props> = forwardRef(({ label, errorMessage, labelClassName, ...restProps }, ref) => {
  const classes = useStyles()

  return (
    <FormControl>
      <FormHelperText className={`${labelClassName} ${classes.lebel}`}>{label}</FormHelperText>
      <Input ref={ref} {...restProps} />
      <FormHelperText className={classes.errorMessage}>{errorMessage}</FormHelperText>
    </FormControl>
  )
})

Field.displayName = 'Field'
export default Field
